import {
  IssueFragment,
  WaitIssueMutation,
  WaitIssueMutationVariables,
  useWaitIssueMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useWaitIssue = withStandardMutationHook<
  WaitIssueMutation,
  IssueFragment,
  WaitIssueMutationVariables,
  'waitIssue',
  [string]
>(useWaitIssueMutation, 'waitIssue', name => ({
  name,
}));
